<template>
  <div id="app" class="trial-balance-page">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="dialogfiltre" scrollable persistent max-width="510px">
      <v-card>
        <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-card flat class="white--text">
            <v-card flat>
              <v-card-actions>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <catimuhasebekodu
                      v-model="searchParams.startAccoutingCode"
                      :controlValue="searchParams.startAccoutingCode"
                      :companyID="credentials.MuhasebeSirketNo"
                      :text="$t('Start-Accounting-Code')"
                      @validateCheck="checkAccoutingValidate()"
                      :Coper="false"
                    ></catimuhasebekodu>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <catimuhasebekodu
                      v-model="searchParams.endAccoutingCode"
                      :controlValue="searchParams.endAccoutingCode"
                      :companyID="credentials.MuhasebeSirketNo"
                      :text="$t('End-Accounting-Code')"
                      @validateCheck="checkAccoutingValidate()"
                      :Coper="false"
                    ></catimuhasebekodu>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-select
                      :items="hesapItems"
                      item-text="ad"
                      item-value="id"
                      label="Hesaplar"
                      v-model="searchParams.WhichAccounts"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-select
                      :items="MizanTuru"
                      item-text="ad"
                      item-value="id"
                      label="Mizan Türü"
                      v-model="searchParams.Type"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-autocomplete
                      hide-details
                      v-model="searchParams.CostCenterCode"
                      :items="masrafmerkezi"
                      :label="$t('Expense-Center-v2')"
                      item-text="CodeName"
                      clearable
                      item-value="Code"
                      max-height="400"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="checked1"
                      label="Sadece Hareket Görenleri Göster"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="checked2"
                      label="Bakiyesi Sıfır Olanları Göster"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      label="Tek Bakiye"
                      v-model="checked3"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="searchParams.ExcludeClosingFiche"
                      label="Kapanış Fişini Dahil Etme"
                      false-value="0"
                      true-value="1"
                    ></v-checkbox>
                  </v-flex>

                  <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="searchParams.ExcludeOpeningFiche"
                      label="Açılış Fişini Dahil Etme"
                      false-value="0"
                      true-value="1"
                    ></v-checkbox>
                  </v-flex>
                   <v-flex xs12 sm12 md12>
                    <v-checkbox
                      v-model="searchParams.ExcludeReflectionFiche"
                      label="Yansıtma Fişini Dahil Etme"
                      false-value="0"
                      true-value="1"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-card>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="filtreiptal()">
            {{ $t('cancel_button') }}
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="filtrekayit()">
            {{ $t('Apply-Filters') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar dark color="info" class="page-toolbar">
            <v-toolbar-title>{{ $t("Accounting-Balance") }}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>

              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title>
                    Html {{ $t("Download") }}
                  </v-list-tile-title>
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title>
                    Excel {{ $t("Download") }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>

        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 style="padding-right: 2px; padding-bottom: 4px">
              <v-card color="#1E88E5" class="white--text summary-card">
                <v-layout>
                  <v-flex xs2 sm2 md2>
                    <v-layout align-center justify-center fill-height>
                      <v-icon color="white" large>cached</v-icon>
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 sm10 md10>
                    <v-card-title primary-title>
                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading">
                                {{ $t("Total-Credit") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading" v-if="tableData.length > 0">
                                : {{ TotalCredit | moneyformat }} {{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading">
                                {{ $t("Total-Balance-Receivable") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading" v-if="tableData.length > 0">
                                : {{ TotalCreditBalance | moneyformat }} {{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-title>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex xs12 sm6 md6 style="padding-right: 2px; padding-bottom: 4px">
              <v-card color="#1E88E5" class="white--text summary-card">
                <v-layout>
                  <v-flex xs2 sm2 md2>
                    <v-layout align-center justify-center fill-height>
                      <v-icon color="white" large>layers</v-icon>
                    </v-layout>
                  </v-flex>

                  <v-flex xs10 sm10 md10>
                    <v-card-title primary-title>
                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading">
                                {{ $t("Total-Debit") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading" v-if="tableData.length > 0">
                                : {{ TotalDept | moneyformat }} {{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-layout>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading">
                                {{ $t("Total-Balance-Debt") }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <v-list-tile-title>
                              <span class="subheading" v-if="tableData.length > 0">
                                : {{ TotalDeptBalance | moneyformat }} {{ getparabirimi() }}
                              </span>
                            </v-list-tile-title>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-card-title>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <v-container fluid>
          <v-card color="grey lighten-5" flat class="report-card">
            <v-form ref="muhasebehesabagore" v-model="valid">
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-model="searchParams.FirstDate"
                    v-bind:value="searchParams.FirstDate"
                  ></tarihcomp>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                    v-model="searchParams.EndDate"
                    v-bind:value="searchParams.EndDate"
                  ></tarihcomp>
                </v-flex>

                <v-flex>
                  <v-layout>
                    <v-btn color="info" @click="getList()" fab small dark>
                      <v-icon>search</v-icon>
                    </v-btn>

                    <v-btn small @click="filtrele()" color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>

            <report-table
              :headers="headers"
              :items="tableData"
              :loading="loadingvmodel"
              :has-searched="hasSearched"
              :storage-key="'trial_balance_report_table'"
              :search-label="$t('Search')"
              :row-class-fn="rowClassFn"
            >
              <template slot="cell" slot-scope="slotProps">
                <span :class="{ 'font-weight-bold': isGrandTotalRow(slotProps.item) }">
                  {{ formatCellValue(slotProps.item, slotProps.column) }}
                </span>
              </template>
            </report-table>
          </v-card>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import ReportTable from "@/components/app/customcomp/ReportTable.vue";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";

export default {
  data() {
    return {
      masrafmerkezi: [],
      hesapItems: [
        { ad: "Tümü", id: 0 },
        { ad: "Alt Hesaplar", id: 1 },
        { ad: "Üst Hesaplar", id: 2 },
        { ad: "Sadece Kebir", id: 3 }
      ],

      dialogfiltre: false,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      hasSearched: false,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0
      },

      valid: true,
      startAccoutingCode: null,
      endAccoutingCode: null,
      checked1: true,
      checked2: true,
      checked3: true,

      searchParams: {
        CompanyID: 0,
        FirstDate: null,
        EndDate: null,
        FirstAccountCode: null,
        EndAccountCode: null,
        ReverseOrder: 0,
        Show0Balance: 1,
        ListTransactionalAccounts: 1,
        WhichAccounts: 0,
        SingleBalance: 1,
        ExcludeClosingFiche: 0,
        ExcludeOpeningFiche: 0,
        ExcludeReflectionFiche:0,
        Type: "0",
        CostCenterCode: "",
        startAccoutingCode: null,
        endAccoutingCode: null
      },

      MizanTuru: [
        { ad: "Normal", id: "0" },
        { ad: "Dövizli", id: "1" }
      ],

      accoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null
      },

      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
      itemDetails: [],

      headers: [
        {
          text: this.$t("Accound-Code"),
          value: "Code",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: this.$t("Account-Name"),
          value: "CodeName",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "240px"
        },
        {
          text: this.$t("Döviz"),
          value: "Currency",
          type: "text",
          align: "left",
          visible: true,
          sortable: true,
          minWidth: "120px"
        },
        {
          text: this.$t("Debit"),
          value: "Dept",
          type: "money",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: this.$t("Credit"),
          value: "Credit",
          type: "money",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "140px"
        },
        {
          text: this.$t("Debt-Balance"),
          value: "DeptBalance",
          type: "money",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "150px"
        },
        {
          text: this.$t("Balance-Receivable"),
          value: "CreditBalance",
          type: "money",
          align: "right",
          visible: true,
          sortable: true,
          minWidth: "170px"
        }
      ],

      TotalCredit: 0,
      TotalCreditBalance: 0,
      TotalDept: 0,
      TotalDeptBalance: 0
    };
  },

  computed: {
    tableData() {
      return Array.isArray(this.items) ? this.items : [];
    }
  },

  methods: {
    getExpenseCenters() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params = {
        CompanyCode: credentials.SirketKodu
      };

      this.$http.post(auth.API_URL + "api/ExpenseCenter/List", params, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader()
        }
      }).then(
        (response) => {
          this.masrafmerkezi = response.body;
        },
        (response) => {
          this.text1 =
            response.status === 0
              ? "Service Unavailable-ExpenseCenter"
              : "Service Unavailable-ExpenseCenter";
          this.snackbar = true;
        }
      );
    },

    filtrekayit() {
      this.dialogfiltre = false;
    },

    filtreiptal() {
      this.dialogfiltre = false;
    },

    filtrele() {
      this.dialogfiltre = true;
    },

    checkAccoutingValidate() {
      this.accoutingCode.CodeID = 0;
    },

    getparabirimi() {
      return helpers.getparabirimi();
    },

    isEmptyValue(val) {
      return val === null || val === undefined || val === "";
    },

    isGrandTotalRow(item) {
      return item && item.CodeName === "Genel Toplam:";
    },

    rowClassFn(item) {
      if (this.isGrandTotalRow(item)) {
        return "report-row summary-total-row";
      }

      return "report-row";
    },

    formatCellValue(item, column) {
      if (!item || !column) {
        return "";
      }

      const value = item[column.value];

      if (column.type === "money") {
        return this.isEmptyValue(value) ? "" : helpers.moneyformat(value);
      }

      return this.isEmptyValue(value) ? "" : value;
    },

    validateDateRange() {
      var bastarih = new Date(this.searchParams.FirstDate);
      var bittarih = new Date(this.searchParams.EndDate);

      if (bastarih <= bittarih) {
        return true;
      }

      this.text1 = this.$t("start-date-cannot-greater-than-end-date");
      this.snackbar = true;
      this.loadingvmodel = false;
      return false;
    },

    prepareSearchParams() {
      this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;

      if (this.searchParams.startAccoutingCode != null) {
        this.searchParams.FirstAccountCode = this.searchParams.startAccoutingCode.Code;
      } else {
        this.searchParams.FirstAccountCode = null;
      }

      if (this.searchParams.endAccoutingCode != null) {
        this.searchParams.EndAccountCode = this.searchParams.endAccoutingCode.Code;
      } else {
        this.searchParams.EndAccountCode = null;
      }

      this.searchParams.ListTransactionalAccounts = this.checked1 ? 1 : 0;
      this.searchParams.Show0Balance = this.checked2 ? 1 : 0;
      this.searchParams.SingleBalance = this.checked3 ? 1 : 0;
    },

    applyTotals(responseBody) {
      this.TotalCredit = 0;
      this.TotalCreditBalance = 0;
      this.TotalDept = 0;
      this.TotalDeptBalance = 0;

      if (this.searchParams.Type == "0") {
        this.TotalCredit = responseBody.TotalCredit || 0;
        this.TotalCreditBalance = responseBody.TotalCreditBalance || 0;
        this.TotalDept = responseBody.TotalDept || 0;
        this.TotalDeptBalance = responseBody.TotalDeptBalance || 0;
      }
    },

    buildItemsWithTotals(responseBody) {
      const details = Array.isArray(responseBody.Details) ? responseBody.Details.slice() : [];
      const result = details.slice();

      if (this.searchParams.Type == "0") {
        result.unshift({
          Code: "",
          CodeName: "Genel Toplam:",
          Currency: "TL",
          Dept: responseBody.TotalDept || 0,
          Credit: responseBody.TotalCredit || 0,
          DeptBalance: responseBody.TotalDeptBalance || 0,
          CreditBalance: responseBody.TotalCreditBalance || 0
        });
      } else {
        const totalsByCurrency = Array.isArray(responseBody.TotalsByCurrency)
          ? responseBody.TotalsByCurrency
          : [];

        for (let i = totalsByCurrency.length - 1; i >= 0; i--) {
          const element = totalsByCurrency[i];
          result.unshift({
            Code: "",
            CodeName: "Genel Toplam:",
            Currency: element.Currency,
            Dept: element.TotalDept,
            Credit: element.TotalCredit,
            DeptBalance: element.TotalDeptBalance,
            CreditBalance: element.TotalCreditBalance
          });
        }
      }

      return result;
    },

    getList() {
      if (!this.validateDateRange()) {
        return;
      }

      this.items = [];
      this.hasSearched = true;

      if (!this.$refs.muhasebehesabagore.validate()) {
        return;
      }

      this.loadingvmodel = true;
      this.prepareSearchParams();

      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/TrialBalanceList",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }
        )
        .then(
          (response) => {
            const body = response.body || {};
            const details = Array.isArray(body.Details) ? body.Details : [];

            if (details.length > -1) {
              this.applyTotals(body);
              this.items = this.buildItemsWithTotals(body);
              this.loadingvmodel = false;
            } else {
              this.text1 = this.$t("No-Records-Found");
              this.snackbar = true;
              this.items = [];
              this.loadingvmodel = false;
            }
          },
          (response) => {
            this.text1 = response.status === 0 ? "Service Unavailable" : "Service Unavailable";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    },

    getListHtml() {
      if (!this.validateDateRange()) {
        return;
      }

      if (!this.$refs.muhasebehesabagore.validate()) {
        return;
      }

      this.items = [];
      this.loadingvmodel = true;
      this.prepareSearchParams();

      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/TrialBalanceListHtml",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/html"
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeMizan.html";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            this.text1 = response.status === 0 ? "Service Unavailable" : "Service Unavailable";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    },

    getListExcel() {
      if (!this.validateDateRange()) {
        return;
      }

      if (!this.$refs.muhasebehesabagore.validate()) {
        return;
      }

      this.items = [];
      this.loadingvmodel = true;
      this.prepareSearchParams();

      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/TrialBalanceListExcel",
          this.searchParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            },
            responseType: "arraybuffer"
          }
        )
        .then(
          (response) => {
            var blob = new Blob([response.data], {
              type: "application/xlsx"
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = "MuhasebeMizan.xlsx";
            link.click();
            this.loadingvmodel = false;
          },
          (response) => {
            this.text1 = response.status === 0 ? "Service Unavailable" : "Service Unavailable";
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );
    }
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    }
  },

  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
    ReportTable
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },

  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    this.getExpenseCenters();

    if (this.sayfayetki.Status == true) {
      // YETKİ OK
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;
              window.open(url, "_self");
            } else {
              var mainUrl = "#/";
              window.open(mainUrl, "_self");
            }
          }
        });
    }
  }
};
</script>

<style scoped>
.trial-balance-page {
  background: #f5f7fb;
}

.page-toolbar {
  border-radius: 6px 6px 0 0;
}

.summary-card {
  min-height: 116px;
}

.report-card {
  border-radius: 10px;
}

.report-row:hover {
  background: #f8fbff;
}

.summary-total-row {
  background: #e3f2fd !important;
}

.summary-total-row td {
  font-weight: 700;
}

@media (max-width: 960px) {
  .trial-balance-page {
    overflow-x: hidden;
  }
}
</style>